import { render, staticRenderFns } from "./CostTarget.vue?vue&type=template&id=5f987736&scoped=true&"
import script from "./CostTarget.vue?vue&type=script&lang=js&"
export * from "./CostTarget.vue?vue&type=script&lang=js&"
import style0 from "./CostTarget.vue?vue&type=style&index=0&id=5f987736&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f987736",
  null
  
)

export default component.exports